import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    SidebarSubItemContextType,
    SidebarGroupContextType,
    SidebarRootContextType,
    SidebarItemContextType,
    SidebarContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export const SidebarRootContext = createContext<SidebarRootContextType | undefined>(undefined);

export const SidebarItemContext = createContext<SidebarItemContextType | undefined>(undefined);

export const SidebarGroupContext = createContext<SidebarGroupContextType | undefined>(undefined);

export const SidebarGroupLabelContext = createContext<boolean>(false);

export const SidebarSubContext = createContext<boolean>(false);

export const SidebarSubItemContext = createContext<SidebarSubItemContextType | undefined>(undefined);

export const useSidebarContext = ({
    part
}: {
    part: string;
}) => {
    const context = useContext(SidebarContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `${part} must be rendered inside Sidebar.Provider.`
        });
    }, [
        context
    ]);

    return context;
};

export const useSidebarRootContext = ({
    part
}: {
    part: string;
}) => {
    const context = useContext(SidebarRootContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `${part} must be rendered inside Sidebar.`
        });
    }, [
        context
    ]);

    return context;
};

export const useSidebarItemContext = () => {
    return useContext(SidebarItemContext);
};

export const useSidebarGroupContext = ({
    part
}: {
    part: string;
}) => {
    const context = useContext(SidebarGroupContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `${part} must be rendered inside Sidebar.Group.`
        });
    }, [
        context
    ]);

    return context;
};

export const useSidebarSubContext = ({
    part
}: {
    part: string;
}) => {
    const isInsideSub = useContext(SidebarSubContext);

    useEffect(() => {
        if(isInsideSub) {
            return;
        }

        warnOnce({
            message: `${part} must be rendered inside Sidebar.MenuSub.`
        });
    }, [
        isInsideSub
    ]);

    return isInsideSub;
};

export const useSidebarSubItemContext = () => {
    return useContext(SidebarSubItemContext);
};
